import { Controller } from "@hotwired/stimulus"
import { post, destroy } from "@rails/request.js"

export default class extends Controller {
  static values = {
    publisherId: String
  }

  create() {
    post("/subscriptions", {body: {publisher_id: this.publisherIdValue}})
  }

  destroy() {
    destroy(`/subscriptions/${this.publisherIdValue}`)
  }
}
